import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ToastService } from '../../shared/services';
import { AuthService } from '../../services/auth';

@Component({
  selector: 'app-forgot-password',
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './forgot-password.html',
  styleUrls: ['../auth-form.css', './forgot-password.css'],
})
export class ForgotPassword {
  private authService = inject(AuthService);
  private toastService = inject(ToastService);
  private router = inject(Router);
  forgotPasswordForm: FormGroup;
  isSubmitting = false;

  constructor(private fb: FormBuilder) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  get emailControl(): FormControl {
    return this.forgotPasswordForm.get('email') as FormControl;
  }

  onSubmit() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      this.toastService.show(
        'Ingresa un correo válido para enviar la recuperación.',
        'warning'
      );
      return;
    }

    this.isSubmitting = true;
    const { email } = this.forgotPasswordForm.value;

    this.authService.requestPasswordReset(email).subscribe({
      next: (response: { message?: string; isGoogleLinked?: boolean }) => {
        this.isSubmitting = false;
        const message =
          response?.message ||
          'Si el correo existe enviaremos instrucciones para restablecer tu contraseña.';

        if (response?.isGoogleLinked) {
          this.toastService.show(message, 'info', 6000);
          return;
        }

        this.toastService.show(message, 'success');
        this.router.navigate(['/auth/signin']);
      },
      error: (err) => {
        this.isSubmitting = false;
        const apiErrors = err?.error?.errors;
        const message =
          (Array.isArray(apiErrors) && apiErrors.length
            ? apiErrors.join('<br>')
            : err?.error?.message) ||
          'No pudimos procesar tu solicitud. Intenta nuevamente.';
        this.toastService.show(message, 'warning', 6000);
      },
    });
  }
}
